
// typeSquareAPI
// window.addEventListener('load', () => {
//     Ts.loadFont()
// });

// カートの商品点数が0の時はヘッダー内に商品点数を表示しない
(function(ns, fetch) {
    if (typeof fetch !== 'function') return;

        ns.fetch = function() {
        const response = fetch.apply(this, arguments);
        const baseUrl = window.location.origin;
        const endpoints = [
            `${baseUrl}/cart/update.js`,
            `${baseUrl}/cart/change.js`,
            `${baseUrl}/cart/clear.js`,
            `${baseUrl}/cart.js`,
            `${baseUrl}/en/cart/update.js`,
            `${baseUrl}/en/cart/change.js`,
            `${baseUrl}/en/cart/clear.js`,
            `${baseUrl}/en/cart.js`,
        ];
        response.then(res => {
            if (endpoints.includes(res.url)) {
            res.clone().json().then(data => {
                const { item_count } = data;
                const itemCountDisplay = document.getElementById('item_count_display');
                if (itemCountDisplay) {
                    itemCountDisplay.innerHTML = item_count ? `(<cart-count>${item_count}</cart-count>)` : '';
                }
            }).catch(err => {
                console.error("Failed to parse response JSON:", err);
            });
            }
        });

    return response;
    }
} (window, window.fetch));


// チェックアウトボタン挙動調整（利用規約に同意しないとチェックアウトに進めない）
const button = {
    formSelector: '.cart-drawer__footer',
    buttonSelector: '#agreeSubmitButtonDrawerCart'
};

document.addEventListener('DOMContentLoaded', () => {
    const buttons = [
        {
            checkboxId: 'CartPageCheck',
            formSelector: '.cart-page',
            buttonSelector: '#agreeSubmitButtonCartPage'
        },
        {
            checkboxId: 'ProductFormCheck',
            formSelector: '.shopify-product-form',
            buttonSelector: '.shopify-payment-button__button'
        },
        {
            checkboxId: 'ThanksPageCheck',
            formSelector: '.thanks-page-checkout',
            buttonSelector: '#agreeSubmitButtonThanksPage'
        }
    ];

    // 各チェックボックスの状態に基づいてボタンの有効・無効を制御
    buttons.forEach(({ checkboxId, formSelector, buttonSelector }) => {
        const triggerCheckbox = document.getElementById(checkboxId);

        // チェックボックスが存在しない場合は処理をスキップ
        if (!triggerCheckbox) {
            return;
        }

        // チェックボックスの状態変更時にボタンの状態を切り替える
        triggerCheckbox.addEventListener('change', () => toggleButtonState({ triggerCheckbox, formSelector, buttonSelector }));
    });
});

function toggleButtonState({ triggerCheckbox, formSelector, buttonSelector }) {
    // フォームを直接取得
    const targetForm = document.querySelector(formSelector);

    if (!targetForm) {
        console.warn(`Form not found: ${formSelector}`);
        return;
    }

    // 対応するボタンを取得
    const targetButton = targetForm.querySelector(buttonSelector);

    if (!targetButton) {
        console.warn(`Button not found: ${buttonSelector}`);
        return;
    }

    // チェックボックスの状態に応じてボタンのクラスを切り替え
    if (triggerCheckbox.checked) {
        targetButton.classList.add('is-active');
        targetButton.disabled = false;
    } else {
        targetButton.classList.remove('is-active');
        targetButton.disabled = true;
    }
}


// マイページ -> 住所管理ページ
document.addEventListener('DOMContentLoaded', function () {
    // yubinbango.js使用のための都道府県コードをShopify登録用バリュー値に変換
    const provinceMapping = {
        "1": "Hokkaido",
        "2": "Aomori",
        "3": "Iwate",
        "4": "Miyagi",
        "5": "Akita",
        "6": "Yamagata",
        "7": "Fukushima",
        "8": "Ibaraki",
        "9": "Tochigi",
        "10": "Gunma",
        "11": "Saitama",
        "12": "Chiba",
        "13": "Tokyo",
        "14": "Kanagawa",
        "15": "Niigata",
        "16": "Toyama",
        "17": "Ishikawa",
        "18": "Fukui",
        "19": "Yamanashi",
        "20": "Nagano",
        "21": "Gifu",
        "22": "Shizuoka",
        "23": "Aichi",
        "24": "Mie",
        "25": "Shiga",
        "26": "Kyoto",
        "27": "Osaka",
        "28": "Hyogo",
        "29": "Nara",
        "30": "Wakayama",
        "31": "Tottori",
        "32": "Shimane",
        "33": "Okayama",
        "34": "Hiroshima",
        "35": "Yamaguchi",
        "36": "Tokushima",
        "37": "Kagawa",
        "38": "Ehime",
        "39": "Kochi",
        "40": "Fukuoka",
        "41": "Saga",
        "42": "Nagasaki",
        "43": "Kumamoto",
        "44": "Oita",
        "45": "Miyazaki",
        "46": "Kagoshima",
        "47": "Okinawa"
    };


    const forms = document.querySelectorAll('form');

    forms.forEach((form) => {
        const regionSelect = form.querySelector('.p-region-id');
        const actualSendField = form.querySelector('.actually-send');
        const postalCode = form.querySelector('.input-address-id-zip');
        let timerId;

        function updateProvinceValue(selectedValue) {
            if (actualSendField) {
                const mappedValue = provinceMapping[selectedValue] || "";
                actualSendField.value = mappedValue;
                console.log(`都道府県コード: ${selectedValue}, 送信用value: ${mappedValue}`);
            }
        }

        // 郵便番号が変更された時に登録用value値を変更
        if (postalCode) {
            postalCode.addEventListener('keyup', (e) => {
                clearTimeout(timerId);
                timerId = setTimeout(() => {
                    if (regionSelect && regionSelect.value) {
                        updateProvinceValue(regionSelect.value);
                    } else {
                        if (actualSendField) {
                            actualSendField.value = "";
                        }
                    }
                }, 300);
            });
        }

        // 都道府県セレクトボックスが変更された時に登録用value値を変更
        if (regionSelect) {
            regionSelect.addEventListener('change', function () {
                if (regionSelect.value) {
                    updateProvinceValue(regionSelect.value);
                } else {
                    if (actualSendField) {
                        actualSendField.value = "";
                    }
                }
            });
        }

        // 初期値設定
        if (regionSelect && regionSelect.value) {
            updateProvinceValue(regionSelect.value);
        } else {
            if (actualSendField) {
                actualSendField.value = "";
            }
        }
    });
});

// 無効な郵便番号のバリデーションチェック
document.addEventListener('DOMContentLoaded', () => {
    const forms = document.querySelectorAll('form.h-adr');

    forms.forEach((form) => {
        const postalCodeInput = form.querySelector('.p-postal-code');
        const errorMessage = form.querySelector('.js-error-message');
        const submitButton = form.querySelector('button[type="submit"]');

        let debounceTimeout;

        if (!postalCodeInput || !errorMessage || !submitButton) return;

        // 郵便番号の入力監視
        postalCodeInput.addEventListener('input', (event) => {
            const allowedChars = /[０-９0-9]/;
            let value = event.target.value;

            // 許可された文字以外を削除
            value = value.split('').filter(char => allowedChars.test(char)).join('');
            event.target.value = value;

            // 入力中は一時的にエラーを非表示
            errorMessage.style.display = 'none';
            submitButton.disabled = true;

            // 空欄の場合は処理終了
            if (!value.trim()) {
                return;
            }

            // 全角数字を半角数字に変換
            value = value.replace(/[０-９]/g, (char) => String.fromCharCode(char.charCodeAt(0) - 0xFEE0));

            // 入力欄の値を更新
            event.target.value = value;

            // デバウンスでAPIチェックを実行
            clearTimeout(debounceTimeout);
            debounceTimeout = setTimeout(async () => {
                const postalCode = value;

                try {
                    // zipcloud APIを使用して郵便番号をチェック
                    const response = await fetch(`https://zipcloud.ibsnet.co.jp/api/search?zipcode=${postalCode}`);
                    const data = await response.json();

                    if (data && data.results) {
                        // 有効な郵便番号の場合
                        errorMessage.style.display = 'none';
                        submitButton.disabled = false;

                        // フィールド変更イベントを発火して住所自動入力をトリガー
                        postalCodeInput.value = postalCode;
                        postalCodeInput.dispatchEvent(new Event('change', { bubbles: true }));
                    } else {
                        // 無効な郵便番号の場合
                        errorMessage.style.display = 'inline';
                        errorMessage.textContent = '※日本の有効な郵便番号を入力してください';
                        submitButton.disabled = true;
                    }
                } catch (error) {
                    console.error('APIエラー:', error);
                }
            }, 500);
        });
    });
});

function toggleBreadcrumbByHash() {
  const loginBreadcrumb = document.querySelector('.js-breadcrumb-login');
  const recoverBreadcrumb = document.querySelector('.js-breadcrumb-recover-password');

  if (!loginBreadcrumb || !recoverBreadcrumb) return;

  if (window.location.hash === '#recover') {
    loginBreadcrumb.style.display = 'none';
    recoverBreadcrumb.style.display = 'inline';
  } else {
    loginBreadcrumb.style.display = 'inline';
    recoverBreadcrumb.style.display = 'none';
  }
}

window.addEventListener('load', toggleBreadcrumbByHash);
window.addEventListener('hashchange', toggleBreadcrumbByHash);